<template>
  <div class="other-times">
    <ul class="other-times__content">
      <template v-for="item in items">
        <li v-if="item.utc" :key="item.location">
          <time
            data-test-id="other-times-clock-desktop"
            class="other-times__clocktime"
            :datetime="item.time"
          >
            {{ item.clockTime }}
          </time>
          <span class="other-times__location">
            {{ `${item.location} (${item.utc})` }}
          </span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.other-times__content {
  padding: 0;
  list-style: none;
  margin: 0;

  li:not(:first-of-type) {
    margin-top: $space-1s;
  }
}

.other-times__toggle {
  border: none;
  background-color: transparent;
  padding: $space-1s 0;
  color: var(--color-link-secondary);
  margin-bottom: $space-1s;
  cursor: pointer;
  transition: color $timing-2s $easing;

  &:hover,
  &:focus {
    color: var(--color-text-primary);
  }
}

.other-times__clocktime {
  font-weight: $font-weight-1l;
}

.other-times__location {
  margin-left: $space-m;
}

.other-times__icon--flipped {
  transform-origin: center;
  transform: rotateX(180deg);
}
</style>
